import { theme } from "antd";
import { Link, useLocation } from "react-router-dom";

const { useToken } = theme;

const Navigation = ({ mode = "horizontal" }) => {
	const { token } = useToken();
	const location = useLocation();

	const navItems = [
		{
			key: "/",
			label: "Home",
		},
		{
			key: "/pricing",
			label: "Pricing",
		},
		{
			key: "/about",
			label: "About",
		},
		{
			key: "/contact",
			label: "Contact",
		},
	];

	const isActive = (path) => location.pathname === path;

	// Common link styles
	const linkStyle = {
		color: token.colorText,
		padding: "8px 16px",
		textDecoration: "none",
		fontWeight: 500,
		transition: "color 0.2s ease",
	};

	// Active link styles
	const activeLinkStyle = {
		...linkStyle,
		color: token.colorPrimary,
	};

	// Container styles based on mode
	const containerStyle = {
		display: "flex",
		listStyle: "none",
		margin: 0,
		padding: 0,
		flexDirection: mode === "horizontal" ? "row" : "column",
		gap: mode === "horizontal" ? "16px" : "8px",
	};

	return (
		<nav>
			<ul style={containerStyle}>
				{navItems.map((item) => (
					<li key={item.key}>
						<Link
							to={item.key}
							style={isActive(item.key) ? activeLinkStyle : linkStyle}
							onMouseOver={(e) => {
								e.currentTarget.style.color = token.colorPrimary;
							}}
							onMouseOut={(e) => {
								e.currentTarget.style.color = isActive(item.key)
									? token.colorPrimary
									: token.colorText;
							}}
						>
							{item.label}
						</Link>
					</li>
				))}
			</ul>
		</nav>
	);
};

export default Navigation;
